import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import setSelectedFilterOption from './setSelectedFilterOption';
import { incrementGetFileProviderItemsRequestCount } from './helpers/getFileProviderItemsRequestCount';
import clearFileProviderItems from './clearFileProviderItems';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import { action } from 'satcheljs/lib/legacy';

export default action('changeFilterOptionAndReloadItemsForSelectedProvider')(
    function changeFilterOptionAndReloadItemsForSelectedProvider(
        viewState: FilePickerPanelViewState,
        filterBy: AttachmentItemsFilterBy
    ) {
        setSelectedFilterOption(viewState.filePickerViewState.filterOptionsState, filterBy);
        incrementGetFileProviderItemsRequestCount();
        clearFileProviderItems(viewState.filePickerViewState);
        loadMoreItemsForSelectedProvider(viewState);
    }
);
